import * as React from 'react';
import { TPaymentMethod } from './PaymentMethod.types';
import './PaymentMethod.styled.scss';
import {
  Button,
  Card,
  CardContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
} from '@mui/material';
import { TPaymentMethod as TPaymentMethodType } from '../../Checkout.types';
import { PAYMENT_METHODS } from '../../Checkout.constants';
import {
  CreditCard,
  AccountBalance,
  Payment,
  LocalAtm,
} from '@mui/icons-material';

const paymentIcons = {
  card: CreditCard,
  blik: Payment,
  transfer: AccountBalance,
  cash: LocalAtm,
};

export const PaymentMethod: TPaymentMethod = ({
  selectedMethod,
  onMethodSelect,
  onComplete,
  onBack,
  subtotal,
  shippingCost,
}) => {
  const total = subtotal + shippingCost;

  const handleSubmit = () => {
    if (selectedMethod) {
      onComplete(selectedMethod);
    }
  };

  return (
    <div className="payment-method">
      <div className="payment-method__header">
        <h6 className="payment-method__title">Payment Method</h6>
      </div>

      <div className="payment-method__content">
        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            value={selectedMethod || ''}
            onChange={(e) =>
              onMethodSelect(e.target.value as TPaymentMethodType)
            }
          >
            {PAYMENT_METHODS.map((method) => {
              const IconComponent = paymentIcons[method.id];
              return (
                <Card
                  key={method.id}
                  className={`payment-method__card ${
                    selectedMethod === method.id
                      ? 'payment-method__card--selected'
                      : ''
                  }`}
                >
                  <CardContent>
                    <FormControlLabel
                      value={method.id}
                      control={<Radio />}
                      label={
                        <div className="payment-method__info">
                          <div className="payment-method__header-row">
                            {IconComponent && (
                              <IconComponent className="payment-method__icon" />
                            )}
                            <div className="payment-method__text">
                              <h6>{method.name}</h6>
                              <p className="body2">{method.description}</p>
                            </div>
                          </div>
                        </div>
                      }
                    />
                  </CardContent>
                </Card>
              );
            })}
          </RadioGroup>
        </FormControl>
      </div>

      <div className="payment-method__summary">
        <div className="payment-method__summary-row">
          <p>Subtotal</p>
          <p>{subtotal.toFixed(2)} zł</p>
        </div>
        <div className="payment-method__summary-row">
          <p>Shipping</p>
          <p>{shippingCost === 0 ? 'Free' : `${shippingCost.toFixed(2)} zł`}</p>
        </div>
        <Divider className="payment-method__summary-divider" />
        <div className="payment-method__summary-row payment-method__summary-row--total">
          <h6>Total</h6>
          <h6>{total.toFixed(2)} zł</h6>
        </div>
      </div>

      <div className="payment-method__actions">
        <Button
          variant="outlined"
          onClick={onBack}
          className="payment-method__back-button"
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!selectedMethod}
          className="payment-method__complete-button"
        >
          Complete Order
        </Button>
      </div>
    </div>
  );
};
